export default __webpack_public_path__ + "static/media/deliveries_7.13e4924b.png";